import { useEffect, useState } from "react";
import { Menu, MessageCircle, X } from "lucide-react";
import { openWhatsApp } from "@/lib/site";

export const Nav = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <nav className={`nav ${scrolled ? "is-scrolled" : ""}`} data-testid="site-navigation">
      <a className="brand" href="#top" data-testid="brand-home"><img src="/logo.jpg" className="brand-logo" alt="Soho Goa — nightclub in Baga"/></a>
      <div className={`nav-links ${menuOpen ? "is-open" : ""}`}>
        <a href={window.location.pathname === "/" ? "#events" : "/#events"} onClick={() => setMenuOpen(false)} data-testid="nav-events-link"><b>01</b> Events</a>
        <a href={window.location.pathname === "/" ? "#experience" : "/#experience"} onClick={() => setMenuOpen(false)} data-testid="nav-experience-link"><b>02</b> The club</a>
        <a href={window.location.pathname === "/" ? "#visit" : "/#visit"} onClick={() => setMenuOpen(false)} data-testid="nav-visit-link"><b>03</b> Find us</a>
      </div>
      <button className="nav-cta" onClick={() => openWhatsApp()} data-testid="nav-reserve-button"><MessageCircle size={15}/> Reserve a table</button>
      <button className="menu-btn" onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle menu" data-testid="mobile-menu-button">{menuOpen ? <X/> : <Menu/>}</button>
    </nav>
  );
};
